import { cn } from '@/shared/lib/cn';
import { pluralizeRu } from '@/shared/lib/format';
import { useSubscriptionStore } from './useSubscriptionStore';

export function SubscriptionBanner() {
  const daysLeft = useSubscriptionStore((s) => s.daysLeft);
  if (daysLeft == null) return null;

  const red = daysLeft <= 3;
  const bg = red
    ? 'bg-red-50 border-red-200 text-red-900'
    : 'bg-amber-50 border-amber-200 text-amber-900';

  return (
    <div className={cn('border-b px-4 py-2 text-sm', bg)} role="status">
      <span className="font-medium">
        Подписка истекает через {daysLeft}{' '}
        {pluralizeRu(daysLeft, ['день', 'дня', 'дней'])}.
      </span>{' '}
      Обратитесь к администратору платформы для продления.
    </div>
  );
}
